import { render, staticRenderFns } from "./AbaPlanoTrabalho.vue?vue&type=template&id=47f02327&scoped=true"
import script from "./AbaPlanoTrabalho.vue?vue&type=script&lang=js"
export * from "./AbaPlanoTrabalho.vue?vue&type=script&lang=js"
import style0 from "./AbaPlanoTrabalho.vue?vue&type=style&index=0&id=47f02327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f02327",
  null
  
)

export default component.exports